import AOS from "aos";
import lozad from "lozad";
import { setBackgroundElement, detectCloseElement, buttonToTop, clickScrollToDiv, appendCaptchaASP, ToggleItem } from "./helper";
import { header } from "./header";
import { swiperInit } from "./swiper";
import product from "./product";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	swiperInit();
	ToggleItem();
	product.init();
	eachTextStroke();
	buttonToTop();
});

function eachTextStroke() {
	$(".text-border").each(function () {
		$(this).attr("data-content", $(this).text());
	});
}

/*==================== Aos Init ====================*/
AOS.init({
	offset: 100,
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
